<template>
  <div class="el-section">
    <emd-card class="_footer_end">
      <emd-card-header>
        <emd-text tag="h2">{{ $t('invite.create.title') }}</emd-text>
      </emd-card-header>
      <emd-card-content customClass="eu-no-padding">
        <div
          v-if="roles.length === 0"
          class="eu-pa_6 eu-align_center"
        >
          <emd-loader type="_invert"></emd-loader>
        </div>

        <form-invite-create v-else />
      </emd-card-content>
    </emd-card>
  </div>
</template>
<script>
import {
  EmdLoader,
  EmdCard,
  EmdCardHeader,
  EmdCardContent,
  EmdText
} from 'emerald-vue/src/components'
import { mapActions, mapGetters } from 'vuex'
import FormInviteCreate from '@/views/Team/Invites/components/FormInviteCreate.vue'

export default {
  name: 'InvitesCreate',
  components: {
    EmdLoader,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    EmdText,
    FormInviteCreate
  },
  computed: {
    ...mapGetters(['roles'])
  },
  methods: {
    ...mapActions(['GET_ROLES'])
  },
  created () {
    this.GET_ROLES()
  }
}
</script>
